import { supabase } from '../supabaseClient';

/* Accès aux données « jira_import_logs ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchImportLogsByStatus() {
  return supabase
    .from('jira_import_logs')
    .select('*')
    .eq('status', 'pending')
    .order('worklog_date', { ascending: false })
    .limit(100);
}

export function ignoreImportLogs(inconnus) {
  return supabase
    .from('jira_import_logs')
    .update({ status: 'ignored' })
    .in(
      'id',
      inconnus.map((l) => l.id),
    );
}

export function ignoreImportLog(logId) {
  return supabase.from('jira_import_logs').update({ status: 'ignored' }).eq('id', logId);
}

export function markImportLogImported(briqueId, logId, user) {
  return supabase
    .from('jira_import_logs')
    .update({ status: 'imported', brique_id: briqueId, user_id: user.id })
    .eq('id', logId);
}
